/* tslint:disable */
/* eslint-disable */
/**
 * SEC AUDITOR API
 * Mehr unter https://sec-auditor.com
 *
 * The version of the OpenAPI document: 4.5.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface FinalizeUsageBasedInvoices200ResponseFailuresInner
 */
export interface FinalizeUsageBasedInvoices200ResponseFailuresInner {
    /**
     * 
     */
    spName?: string;
    /**
     * 
     */
    invoiceId?: string;
    /**
     * 
     */
    error?: string;
}

/**
 * Check if a given object implements the FinalizeUsageBasedInvoices200ResponseFailuresInner interface.
 */
export function instanceOfFinalizeUsageBasedInvoices200ResponseFailuresInner(value: object): value is FinalizeUsageBasedInvoices200ResponseFailuresInner {
    return true;
}

export function FinalizeUsageBasedInvoices200ResponseFailuresInnerFromJSON(json: any): FinalizeUsageBasedInvoices200ResponseFailuresInner {
    return FinalizeUsageBasedInvoices200ResponseFailuresInnerFromJSONTyped(json, false);
}

export function FinalizeUsageBasedInvoices200ResponseFailuresInnerFromJSONTyped(json: any, ignoreDiscriminator: boolean): FinalizeUsageBasedInvoices200ResponseFailuresInner {
    if (json == null) {
        return json;
    }
    return {
        
        'spName': json['spName'] == null ? undefined : json['spName'],
        'invoiceId': json['invoiceId'] == null ? undefined : json['invoiceId'],
        'error': json['error'] == null ? undefined : json['error'],
    };
}

export function FinalizeUsageBasedInvoices200ResponseFailuresInnerToJSON(json: any): FinalizeUsageBasedInvoices200ResponseFailuresInner {
    return FinalizeUsageBasedInvoices200ResponseFailuresInnerToJSONTyped(json, false);
}

export function FinalizeUsageBasedInvoices200ResponseFailuresInnerToJSONTyped(value?: FinalizeUsageBasedInvoices200ResponseFailuresInner | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'spName': value['spName'],
        'invoiceId': value['invoiceId'],
        'error': value['error'],
    };
}

